module.exports = __webpack_public_path__ + "img/pic_03_sel.c8294254.png";